// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "*{\n    font-family: 'Barlow', 'monospace' !important;\n}", "",{"version":3,"sources":["webpack://./src/components/modals/manage-program-modal/manage-program-modal.css"],"names":[],"mappings":"AAAA;IACI,6CAA6C;AACjD","sourcesContent":["*{\n    font-family: 'Barlow', 'monospace' !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
